import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import axios from "axios";
import env from "react-dotenv";
import { getCookie, redirectToSignin } from "./helpers";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import "bootstrap/dist/css/bootstrap.min.css";

Bugsnag.start({
  apiKey: "d80bec9c094bbe977203eb727291ea9b",
  plugins: [new BugsnagPluginReact()],
});

axios.defaults.baseURL = env.REACT_APP_API_ROOT;
axios.defaults.headers.common["Authorization"] = getCookie("ez_t");

// the ez_t cookie outlives the JWT inside it, so a stale session looks signed
// in right up until the first request comes back rejected
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      redirectToSignin();
    }

    return Promise.reject(error);
  }
);

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

ReactDOM.render(
  <ErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);
